<template>
	<path :d="path" />
</template>

<script>
import toPath from "element-to-path";

export default {
	name: 'SVGElementClips',
	props: {
		width: {
			type: Number,
			requred: true,
		},
		height: {
			type: Number,
			requred: true,
		},
		shapes: {
			type: Array,
			requred: true,
		},
	},
	computed: {
		shapePath() {
			const paths = this.shapes.map((shape) => toPath(shape));
			return paths.join(" ");
		},
		base() {
			return `M0,0 L0,${this.height} L${this.width},${this.height} L${this.width},0 L0,0`;
		},
		path() {
			return `${this.base} ${this.shapePath}`;
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/base/SVGElementClips.vue